import styled from 'styled-components';

export const Container = styled.div``;
export const Card = styled.div`
  background: #ffffffb2;
  border: 1px solid #e2e8f099;
  box-shadow:
    0px 8px 10px -6px #0000001a,
    0px 20px 25px -5px #0000001a;
  border-radius: 24px;
  padding: 20px 25px 28px;
  position: relative;
`;
export const Title = styled.h3`
  font-weight: 700;
  font-size: 25px;
  letter-spacing: 0.4px;
  color: #212529;
  margin-bottom: 10px;
`;
export const SubTitle = styled.p`
  font-weight: 400;
  font-size: 16px;
  letter-spacing: -0.31px;
  color: #4a5565;
  margin-bottom: 25px;
`;
export const InputsGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
  border-bottom: 1px solid #e5e7eb;
  padding-bottom: 20px;
  & > div {
    flex: 0 0 auto;
    width: 304px;
    min-height: auto;
  }

  @media (max-width: 575px) {
    & > div {
      width: 100%;
    }
  }
  input:focus {
    ${(props) =>
      !props.$isReadOnly &&
      `
      outline: none;
    `}
  }
`;
export const TimelineContainer = styled.div`
  margin-top: 24px;
`;

export const TimelineLabel = styled.div`
  font-size: 14px;
  color: #364153;
  margin-bottom: 11.5px;
  font-weight: 500;
`;

export const TimelineRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

const getBgColor = (type) => {
  if (type === 'period') return '#FEF2F2';
  if (type === 'submit') return '#EFF6FF';
  if (type === 'review') return '#F0FDF4';
  return '#f8f9fa';
};

const getDotColor = (type) => {
  if (type === 'period') return '#FB424B';
  if (type === 'submit') return '#2B7FFF';
  if (type === 'review') return '#1BC48B';
  return '#d9d9d9';
};

export const TimelineItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: ${(props) => getBgColor(props.$type)};
  border-radius: 10px;
  font-size: 14px;
  color: #364153;
  font-weight: 400;
  min-width: 238px;

  .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: ${(props) => getDotColor(props.$type)};
  }
`;

export const TimelineArrow = styled.img``;
export const EditImg = styled.img`
  position: absolute;
  right: 32px;
  top: 28px;
  cursor: pointer;
`;
export const SaveButtonWrapper = styled.div`
  display: flex;
  margin-left: auto;
  @media (max-width: 1300px) {
    width: 100%;
    justify-content: flex-end;
    margin-top: 15px;
  }
`;

export const SaveButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #3c76e1;
  color: #ffffff;
  padding: 12px 24px;
  border-radius: 10px;
  border: none;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;
  box-shadow:
    0px 4px 6px -4px #2b7fff4d,
    0px 10px 15px -3px #2b7fff4d;
  transition: opacity 0.2s;
  width: fit-content;
  justify-content: center;

  &:hover {
    opacity: 0.9;
  }
  &:disabled {
    cursor: not-allowed;
    box-shadow: none;
    background-color: #3c76e133;
  }
`;
export const SaveImg = styled.img``;
